import React from 'react'
import styled from 'styled-components'
import { CookiesTable, CookiesTableProps } from '@sentecacommerce-theme/lib'
import { Button } from '../../../Common'
import { IconArrowLeft } from '../../../Common/Icons'

export const Details = ({
  goBack,
  handleBack,
  details: labels,
  cookie,
  cookiesMap,
}: DetailsProps) => {
  return (
    <>
      <Content>
        <StyledButton
          icon={<IconArrowLeft />}
          iconPosition="left"
          onClick={handleBack}
          label={goBack}
          fullWidth
          variant="secondary"
          style={{ marginTop: '-1.5rem', marginBottom: '1rem' }}
        />
        <TableBackground>
          <CookiesTable
            details={labels}
            cookie={cookie}
            cookiesMap={cookiesMap}
          />
        </TableBackground>
      </Content>
    </>
  )
}

interface DetailsProps extends CookiesTableProps {
  goBack: string
  handleBack: () => void
}
const Content = styled.div``

const StyledButton = styled(Button)`
  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    transition: all 0.15s ease-in;
    &:hover {
      background: ${({ theme }) => theme.palette.surfCrest};
    }
  }
`
const TableBackground = styled.div`
  background: ${({ theme }) => theme.palette.lightgrey};
`
